module.exports = "<button class=\"kd-button\"\r\n    ng-click=\"$ctrl.generar=true\"\r\n    ng-disabled=\"!$ctrl.empresas.length || !$ctrl.fecha\"\r\n    type=\"button\">\r\n  Exportar\r\n</button>\r\n<finances-saldoempleados-exportar-confirmar\r\n    ng-if=\"$ctrl.generar\"\r\n    empresas=\"$ctrl.empresas\"\r\n    fecha=\"$ctrl.fecha\"\r\n    on-close=\"$ctrl.generar = false\"></finances-saldoempleados-exportar-confirmar>\r\n\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/components/saldoempleados/exportar/template.html
// module id = 2838
// module chunks = 0